import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["messageRoot", "errorCode", "objectTypeId", "objectId"];
import { getRecordHref } from '../../utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { FormattedErrorMessage } from './FormattedErrorText';
import { jsx as _jsx } from "react/jsx-runtime";
const ERROR_CODES_WITH_JSX_MESSAGE = ['REJECTED_APPROVAL_ONLY_TO_CLOSED_LOST'];
const getRecordUrl = (objectTypeId, objectId) => {
  return objectTypeId && objectId && `${window.location.origin}${getRecordHref(objectTypeId, objectId)}?approvalOpen=true`;
};
const getMessageExtraOptions = (errorCode, objectTypeId, objectId) => {
  const optionsMap = {
    REJECTED_APPROVAL_ONLY_TO_CLOSED_LOST: {
      href: getRecordUrl(objectTypeId, objectId),
      disabled: !objectTypeId || !objectId
    }
  };
  return optionsMap[errorCode] || {};
};
export const FormattedErrorDescription = _ref => {
  let {
      messageRoot,
      errorCode,
      objectTypeId,
      objectId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasJSX = ERROR_CODES_WITH_JSX_MESSAGE.includes(errorCode);
  const extraOptions = getMessageExtraOptions(errorCode, objectTypeId, objectId);
  return hasJSX ? /*#__PURE__*/_jsx(FormattedErrorMessage, {
    messageRoot: messageRoot,
    errorCode: errorCode,
    elements: Object.assign({}, rest.elements, {
      Link
    }),
    options: Object.assign({}, rest.options, extraOptions),
    hasJSX: true
  }) : /*#__PURE__*/_jsx(FormattedErrorMessage, Object.assign({
    messageRoot: messageRoot,
    errorCode: errorCode
  }, rest));
};